import { fetchFCMToken, handleIncomingMessages, initializeFirebase } from './fcm';
import { registerServiceWorker } from './serviceWorker';
import { requestNotificationPermission } from './permissions';

(async () => {
    try {
        if (usePush !== undefined && usePush === 'Y') {
            // Firebase 초기화
            const { messaging, vapidKey } = await initializeFirebase();
            // console.log('vapidKey:', vapidKey);

            // 사용자 동작을 기다려 알림 권한 요청
            const permission = await requestNotificationPermission();
            if (permission.includes('granted')) {
                const token = await fetchFCMToken(messaging, vapidKey, permission);

                // Foreground 메시지 수신 처리
                await handleIncomingMessages(messaging);
            } else {
                // console.log('Unable to initialize FCM due to lack of permission.');
            }

            // 서비스 워커 등록
            registerServiceWorker();
        }
    } catch (error) {
        console.error('Failed to initialize Firebase:', error);
    }
})();
